/* Kiomia - carrello a scomparsa: regali automatici, cross-sell delle ricariche,
   pulsanti d'acquisto sparsi nella pagina prodotto.

   I regali. Niente e' cablato sul soffione: km-boot.liquid stampa una mappa
   variante-comprata -> variante-regalata + quantita, costruita dai metacampi
   delle varianti. Qui si tiene solo il carrello allineato a quella mappa:
   aggiunta la confezione compaiono i regali, tolta la confezione spariscono.
   A portarli a zero e' lo sconto automatico corrispondente, che vive in Admin.

   Le righe regalo si riconoscono dalla proprieta' _regalo. Piu' regali diversi
   nello stesso carrello sono previsti: si ragiona per variante regalata, non per
   riga.

   La sezione km-cart-upsell viene chiesta al server e inserita sopra il piede del
   carrello.

   Dieci cose imparate a spese nostre.

   1) Il cassetto che si apre bianco. Liquid marca <cart-drawer class="drawer is-empty">
      quando la pagina parte col carrello vuoto. Se poi si aggiunge un prodotto, Dawn
      rifa il contenuto ma quella classe resta attaccata al tag esterno, che nessuno
      tocca. E il CSS di Dawn con quella classe nasconde la testata e .cart__contents:
      il cassetto si apre vuoto, con solo il totale in fondo. Qui la classe viene
      riallineata al numero di righe presenti davvero.

   2) Dove ridisegna Dawn. Non sostituisce i figli di #CartDrawer: riscrive il contenuto
      di .drawer__inner, che sta un livello piu sotto. Un osservatore senza subtree non
      se ne accorge mai, e il cross-sell spariva a ogni aggiunta. Ora si osserva il
      sottoalbero, con una pausa per non rincorrere ogni singola modifica.

   3) Il regalo che si faceva pagare. Il blocco contro le chiamate sovrapposte si
      alzava dentro la risposta di cart.js, cioe' troppo tardi: partivano due giri,
      tutti e due leggevano un carrello senza regalo, e tutti e due aggiungevano.
      Adesso il blocco si alza PRIMA della lettura, e chi trova occupato si
      ripresenta dopo.

   4) Perche' l'errore non si riparava da solo. Si teneva una sola riga regalo e si
      confrontava la sua quantita con quella attesa: il conto tornava e la riga di
      troppo restava li per sempre. Adesso si raccolgono TUTTE le righe regalo di
      ogni variante: le eccedenti si azzerano e la prima si porta alla quantita
      giusta.

   5) La mappa vuota. Se la collezione dei bundle sparisce o non e' pubblicata, la
      mappa non viene stampata. In quel caso qui non si tocca niente: cancellare i
      regali dai carrelli di tutti sarebbe molto peggio che non aggiungerli.

   6) Lo scatto del cross-sell. Quando entrano i regali, Dawn ridisegna il cassetto
      con l'HTML del server, che il cross-sell non ce l'ha: spariva. Adesso l'ultimo
      cross-sell buono resta in memoria e viene riattaccato nello stesso istante del
      ridisegno, prima che il browser dipinga.

   7) Il cross-sell che restava indietro. Rimettere la copia salvata risolveva lo
      scatto ma ne creava uno peggiore: il riquadro c'era, quindi nessuno andava
      piu a rileggerlo, e continuava a proporre roba entrata nel frattempo nel
      carrello - i regali, per dire. Ogni ridisegno quindi riattacca la copia E
      richiede subito la sezione al server.

   8) La serratura che mangiava l'aggiornamento. Punto 7 da solo non bastava:
      caricando scartava la richiesta se una era gia in volo, e la piu' comune di
      tutte - quella partita col carrello ancora senza regali - arrivava dopo e
      vinceva. Adesso chi trova occupato alza daRicaricare, e appena la richiesta
      in corso si chiude ne parte un'altra.

   9) La risposta che non e' una sezione. Se il server risponde con una pagina
      intera - 500, pagina password, redirect - dentro non c'e' nessun
      data-km-upsell: prima quella risposta cancellava il riquadro e svuotava la
      memoria. Adesso una risposta che sa di documento HTML viene ignorata.

  10) Il regalo che restava a pagamento. Il flag bloccato, che serve solo a non
      rincorrere le nostre stesse inserzioni del cross-sell, usciva da sistema()
      PRIMA di pareggia(). Se il cliente toglieva il soffione mentre quel flag era
      alzato, il giro dei regali non partiva e le righe regalo restavano nel
      carrello, questa volta a prezzo pieno perche' lo sconto non si applicava
      piu: 44,80 € di roba mai scelta. Adesso pareggia() gira SEMPRE, e il flag
      vale solo per il cross-sell. Per lo stesso motivo si osserva anche la
      pagina /cart, dove Dawn ridisegna l'elenco senza toccare il cassetto.

   Nessun file di Dawn viene toccato. */
(function(){
  var caricando = false;
  var daRicaricare = false;
  var bloccato  = false;
  var sistemando = false;
  var daRifare = false;
  var attesa = null;
  var ultimoUpsell = null;

  function radice(){ return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function contenitore(){ return document.getElementById('CartDrawer') || document.querySelector('cart-drawer'); }
  function pannello(){ return document.querySelector('cart-drawer .drawer__inner'); }
  function mappaRegali(){
    var n = document.querySelector('[data-km-gift]');
    if (!n) return null;
    var dati;
    try { dati = JSON.parse(n.textContent); } catch(e){ return null; }
    if (!dati || !dati.regali) return null;
    for (var k in dati.regali) { if (Object.prototype.hasOwnProperty.call(dati.regali, k)) return dati.regali; }
    return null;
  }

  /* ---- is-empty allineata a quello che c'e davvero dentro ---- */
  function allineaVuoto(){
    var dr = document.querySelector('cart-drawer');
    if (!dr) return;
    var righe = dr.querySelectorAll('.cart-item').length;
    var lista = dr.querySelector('cart-drawer-items');
    var interno = dr.querySelector('.drawer__inner');
    if (righe > 0) {
      dr.classList.remove('is-empty');
      if (lista) lista.classList.remove('is-empty');
      if (interno) interno.classList.remove('is-empty');
    } else {
      dr.classList.add('is-empty');
      if (lista) lista.classList.add('is-empty');
    }
  }

  /* ---- Il giro completo dopo ogni ridisegno ---- */
  function sistema(){
    allineaVuoto();
    var inner = pannello();
    if (!bloccato && inner && !inner.querySelector('[data-km-upsell]')) { riattacca(); carica(); }
    pareggia();
  }
  function sistemaFraPoco(){
    if (attesa) clearTimeout(attesa);
    attesa = setTimeout(function(){ attesa = null; sistema(); }, 160);
  }

  /* Le aggiunte al carrello passano da renderContents. I pulsanti piu e meno del
     cassetto no: quelli riscrivono .drawer__inner per conto loro, e li' ci pensa
     l'osservatore. Ci si aggancia una volta sola, sul prototipo. */
  function agganciaRender(){
    var Classe = window.customElements && customElements.get('cart-drawer');
    if (!Classe || !Classe.prototype || Classe.prototype.__kmAggancio) return;
    var originale = Classe.prototype.renderContents;
    if (typeof originale !== 'function') return;
    Classe.prototype.__kmAggancio = true;
    Classe.prototype.renderContents = function(){
      var esito = originale.apply(this, arguments);
      allineaVuoto();
      riattacca();
      carica();
      setTimeout(function(){ allineaVuoto(); sistema(); }, 0);
      setTimeout(allineaVuoto, 300);
      return esito;
    };
  }

  /* ---- Regali: quantita allineata a quello che c'e nel carrello ---- */
  function pareggia(){
    var regali = mappaRegali();
    if (!regali) return;
    if (sistemando) { daRifare = true; return; }
    sistemando = true;

    var sezioni = ['cart-drawer','cart-icon-bubble'];

    function libera(){
      sistemando = false;
      if (daRifare) { daRifare = false; setTimeout(pareggia, 90); }
    }
    function chiudi(j){
      var dr = document.querySelector('cart-drawer');
      if (j && !j.status && dr && typeof dr.renderContents === 'function' && j.sections) dr.renderContents(j);
      allineaVuoto();
      libera();
    }

    /* Una richiesta alla volta: /cart/change.js rinumera le righe a ogni
       chiamata, quindi le correzioni non si possono sparare in parallelo.
       Le chiavi di riga restano valide, gli indici no: si usano le chiavi.
       Se un passo intermedio fallisce - tipico quando il carrello e' stato
       toccato in un'altra scheda del browser - si smette, perche' insistere
       sulla stessa lista di passi vecchia rifarebbe lo stesso errore in giro. */
    function avanti(passi, i){
      var ultimo = (i === passi.length - 1);
      var p = passi[i];
      var indirizzo, corpo;
      if (p.agg != null) {
        indirizzo = radice() + 'cart/add.js';
        corpo = { items: [{ id: p.agg, quantity: p.q, properties: { _regalo: '1' } }] };
      } else {
        indirizzo = radice() + 'cart/change.js';
        corpo = { id: p.key, quantity: p.q };
      }
      if (ultimo) { corpo.sections = sezioni; corpo.sections_url = window.location.pathname; }
      fetch(indirizzo, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(corpo)
      })
        .then(function(r){ return r.json(); })
        .then(function(j){
          if (ultimo) { chiudi(j); return; }
          if (j && j.status) { libera(); return; }
          avanti(passi, i + 1);
        })
        .catch(libera);
    }

    fetch(radice() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        var attesi = {};   /* variante regalata -> quanti pezzi ci vogliono */
        var righe  = {};   /* variante regalata -> righe _regalo gia presenti */

        (c.items || []).forEach(function(it){
          var r = regali[String(it.variant_id)];
          if (r && r.g && r.n > 0) {
            /* Una confezione puo' regalare piu' varianti, quindi la mappa porta
               una lista. La forma vecchia con un id solo resta accettata. */
            var gs = Object.prototype.toString.call(r.g) === '[object Array]' ? r.g : [r.g];
            gs.forEach(function(gid){
              if (gid === null || gid === undefined) return;
              var k = String(gid);
              attesi[k] = (attesi[k] || 0) + (r.n * it.quantity);
            });
          }
          if (it.properties && it.properties._regalo) {
            var kk = String(it.variant_id);
            if (!righe[kk]) righe[kk] = [];
            righe[kk].push(it);
          }
        });

        var passi = [];
        var visti = {};

        /* Righe regalo gia nel carrello: si azzerano le doppie, si corregge la
           prima. Una riga marcata regalo che non e' piu prevista da nessuna
           confezione va a zero: e' un avanzo, e lasciarla vuol dire farla
           pagare. */
        Object.keys(righe).forEach(function(k){
          visti[k] = true;
          var lista = righe[k];
          var voluto = attesi[k] || 0;
          for (var i = 1; i < lista.length; i++) passi.push({ key: lista[i].key, q: 0 });
          if (lista[0].quantity !== voluto) passi.push({ key: lista[0].key, q: voluto });
        });

        /* Regali previsti che ancora non ci sono. */
        Object.keys(attesi).forEach(function(k){
          if (!visti[k] && attesi[k] > 0) passi.push({ agg: Number(k), q: attesi[k] });
        });

        if (!passi.length) { libera(); return; }
        avanti(passi, 0);
      })
      .catch(libera);
  }

  /* ---- Cross-sell nel cassetto ---- */
  function metti(html, ricorda){
    var inner = pannello();
    if (!inner) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var nodo = tmp.querySelector('[data-km-upsell]');
    var vecchio = inner.querySelector('[data-km-upsell]');
    if (vecchio) vecchio.parentNode.removeChild(vecchio);
    if (ricorda) ultimoUpsell = nodo ? nodo.outerHTML : null;
    if (!nodo) return;
    bloccato = true;
    var piede = inner.querySelector('.drawer__footer');
    if (piede) inner.insertBefore(nodo, piede); else inner.appendChild(nodo);
    setTimeout(function(){ bloccato = false; }, 120);
  }

  /* Quello che arriva dal server: comanda lui, e aggiorna la memoria. Una
     risposta che e' una pagina intera non e' la nostra sezione: si lascia stare
     tutto com'e' invece di cancellare il riquadro. */
  function inserisci(html){
    var t = html ? String(html).toLowerCase() : '';
    if (t.indexOf('<html') > -1 || t.indexOf('<!doctype') > -1) return;
    metti(html, true);
  }

  /* Subito dopo un ridisegno di Dawn: si rimette l'ultimo buono, senza toccare
     la memoria. Serve solo a non far vedere il buco, e dura il tempo che la
     versione fresca arrivi dal server. */
  function riattacca(){
    if (!ultimoUpsell) return;
    var inner = pannello();
    if (!inner || inner.querySelector('[data-km-upsell]')) return;
    metti(ultimoUpsell, false);
  }

  /* Chi trova occupato non viene buttato: si segna, e appena la richiesta in
     corso si chiude ne parte un'altra. */
  function carica(){
    if (!pannello()) return;
    if (caricando) { daRicaricare = true; return; }
    caricando = true;
    function dopo(ritardo){
      caricando = false;
      if (daRicaricare) { daRicaricare = false; setTimeout(carica, ritardo); }
    }
    fetch(radice() + '?section_id=km-cart-upsell', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' })
      .then(function(r){ return r.text(); })
      .then(function(t){ dopo(0); inserisci(t); })
      .catch(function(){ dopo(400); });
  }

  function errore(box, testo){
    if (!box) return;
    var e = box.querySelector('[data-km-up-err]');
    if (e) { e.textContent = testo || 'Non siamo riusciti ad aggiungerlo. Riprova.'; e.hidden = false; }
  }

  function aggiungi(btn){
    var id = btn.getAttribute('data-id');
    if (!id) return;
    var box = btn.closest('[data-km-upsell]');
    btn.disabled = true;
    var dr = document.querySelector('cart-drawer');
    var corpo = { items: [{ id: Number(id), quantity: 1 }] };
    if (dr) { corpo.sections = ['cart-drawer','cart-icon-bubble']; corpo.sections_url = window.location.pathname; }
    fetch(radice() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(corpo)
    })
      .then(function(r){ return r.json(); })
      .then(function(j){
        if (j.status) { btn.disabled = false; errore(box, j.description || j.message); return; }
        /* Il prodotto aggiunto esce dal cross-sell: la memoria va buttata,
           altrimenti riattacca() rimetterebbe la scheda di quello che c'e gia. */
        ultimoUpsell = null;
        if (dr && typeof dr.renderContents === 'function') { dr.renderContents(j); allineaVuoto(); }
        else window.location.href = radice() + 'cart';
      })
      .catch(function(){ btn.disabled = false; errore(box); });
  }

  document.addEventListener('click', function(e){
    if (!e.target.closest) return;

    var b = e.target.closest('[data-km-up-add]');
    if (b) { e.preventDefault(); aggiungi(b); return; }

    /* Pulsanti d'acquisto sparsi nella pagina prodotto: fanno partire il modulo principale. */
    var c = e.target.closest('[data-km-buy]');
    if (c) {
      var f = document.querySelector('.km-pdp__form');
      if (!f) return;
      e.preventDefault();
      var scheda = document.querySelector('[data-km-pdp]');
      if (scheda) { try { scheda.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch(err){} }
      if (typeof f.requestSubmit === 'function') f.requestSubmit(); else f.submit();
    }
  });

  /* Si osservano due posti: #CartDrawer, che il tema non distrugge mai, e
     l'elenco della pagina /cart. Serve il sottoalbero, perche' Dawn riscrive il
     contenuto e non i figli diretti. La pausa evita di rincorrere le micro
     modifiche (spinner, campo quantita) e le nostre stesse inserzioni. */
  function guarda(nodo){
    if (!nodo || nodo.getAttribute('data-km-osservato')) return;
    nodo.setAttribute('data-km-osservato','1');
    new MutationObserver(sistemaFraPoco).observe(nodo, { childList: true, subtree: true });
  }
  function osserva(){
    guarda(contenitore());
    guarda(document.getElementById('main-cart-items') || document.querySelector('cart-items'));
  }

  function init(){
    agganciaRender();
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer').then(agganciaRender).catch(function(){});
    }
    osserva(); allineaVuoto(); carica(); pareggia();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function(){ osserva(); sistema(); });
})();